
/* injects from baggage-loader */

import AlertModule from './alert/alert.module';
import PuzzleModule from './puzzle/puzzle.module';
import MenuModule from './menu/menu.module';
import DialogInterventionalModule from './interventional/interventional.module';
import DialogTrophiesModule from './trophies/trophies.module';
import DialogFormsModule from './forms/forms.module';
import DialogIntroModule from './intro/intro.module';
import DialogIntroBookModule from './intro-book/intro-book.module';
import DialogStagesModule from './stages/stages.module';

const shared = angular.module('dialog-module', [
  AlertModule.name,
  PuzzleModule.name,
  MenuModule.name,
  DialogInterventionalModule.name,
  DialogTrophiesModule.name,
  DialogFormsModule.name,
  DialogIntroModule.name,
  DialogIntroBookModule.name,
  DialogStagesModule.name
]);

export default shared;


// WEBPACK FOOTER //
// ./src/app/components/dialogs/dialogs.module.js